import React, { Suspense } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Utils from '../../services/Utils'
import { Link } from 'react-router-dom'
import { LanguageService } from '../../services/LanguageService'
import LogoImage from './LogoImage'
import { setMobileNavMenuOpen } from '../../actions/UserActions'
import { template } from '../../constants/Configs';
// import ColorModeSwitch from './ColorModeSwitch'
const ColorModeSwitch = React.lazy(() => import('./ColorModeSwitch'));
import SiteEvent from '../../services/events/SiteEvent'

class Logo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isTablet: Utils.isTablet()
        }
        this.calculateMenuWidths = this.calculateMenuWidths.bind(this);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.calculateMenuWidths);
    }

    componentDidMount() {
        window.addEventListener("resize", this.calculateMenuWidths);
    }

    calculateMenuWidths() {
        this.setState({ isTablet: Utils.isTablet() });
    }
    onLogoClick() {
        this.props.dispatch(setMobileNavMenuOpen(false))
    }
    handleImageLoad = (width, height) => {
        this.props.onLoad && this.props.onLoad(width, height)
    }
    getLogoLink({ logoUrl, logoLink }) {
        let link = ''
        if (logoUrl) {
            link = logoUrl
        } else if (logoLink?.value) {
            link = logoLink?.value ? (Utils.checkAbsolutePath(logoLink.value) ? Utils.fixAbsoluteUrl(logoLink.value) : logoLink.value) : '#';
        }
        return link;
    }
    render() {
        let { logo = {}, isLoading, logoUrl, isLogoFavicon } = this.props;
        if (logo.faviconUrl && logo.faviconUrl.value) {
            if (document.querySelector("link[rel='shortcut icon']")) {
                document.querySelector("link[rel='shortcut icon']").setAttribute('href', `/${logo.faviconUrl.value}?v=${logo.faviconUrl.lastUpdateTime}`);
            } else {
                var link = document.createElement('link');
                link.rel = 'shortcut icon';
                document.head.appendChild(link);
                link.href = `/${logo.faviconUrl.value}?v=${logo.faviconUrl.lastUpdateTime}`;
            }
        }
        const logoSize = document.getElementsByClassName('logoBlock_img')[0]?.clientWidth
        let logoLink = this.getLogoLink({ ...logo, logoUrl })
        return (
            <React.Fragment>
                {!isLoading ? Utils.checkAbsolutePath(logo.logoLink?.value) ?
                    <>
                        <a className="logoBlock" onClick={(e) => {
                            this.onLogoClick();
                            SiteEvent.dispatch({
                                target: 'logo',
                                rootTarget: 'header',
                                category: SiteEvent.category.Navigation,
                                type: e.type
                            })
                        }}
                            target={logo && logo.logoLink && logo.logoLink.target ? `_${logo.logoLink.target}` : ""}
                            href={logoLink}>
                            <LogoImage className={`logoBlock_img`} logo={logo} onLoad={this.handleImageLoad} />
                        </a>
                        {/* {!config.IS_AFFILIATE && <CountDown />} */}
                    </> :
                    <>
                        <Link className="logoBlock"
                            onClick={(e) => {
                                this.onLogoClick();
                                SiteEvent.dispatch({
                                    target: 'logo',
                                    rootTarget: 'header',
                                    category: SiteEvent.category.Navigation,
                                    type: e.type
                                })
                            }
                            }
                            target={logo?.logoLink?.target ? `_${logo.logoLink.target}` : ""}
                            to={logoLink}>
                            <LogoImage className={`logoBlock_img`} logo={logo} isLogoFavicon={isLogoFavicon} width={logoSize} onLoad={this.handleImageLoad} />
                        </Link>
                        {/* {!config.IS_AFFILIATE && !Utils.isTablet() ? <CountDown /> : ""} */}
                        <Suspense fallback={<></>} >
                         {!this.props.hideColorModeSwitch ?
                          <ColorModeSwitch isVisible={template !== 5 && template !== 7 && !this.state.isTablet} />  : null}
                        </Suspense>
                    </>
                    :
                    <>
                        <div className='logo--empty'></div>
                        {/* {!config.IS_AFFILIATE && <CountDown />} */}
                    </>
                }
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        logo: state.settings.logo,
        isLoading: state.settings.isLoading
    };
};

export default withRouter(connect(
    mapStateToProps,
    null
)(Logo));
